var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.593 12.188h-1.187V.592c0-.325.268-.593.593-.593.325 0 .594.268.594.593v11.595Z",
    fill: "#E8AA60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.703 6.191c-3.242-2.95-4.867 2.95-8.11 0V.853c3.243 2.95 4.868-2.95 8.11 0v5.338Z",
    fill: "#51BF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.877 24.099H50.13v2.697H1.877V24.1Z",
    fill: "#B33254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.877 26.796H50.13V52H1.877V26.796Z",
    fill: "#7CA3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34 26.796h21.32v19.208H15.34V26.796Z",
    fill: "#5E5E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 26.796H10.7v1.122c0 .422.342.771.772.771h4.063a.771.771 0 0 0 .772-.771v-1.122H16.3Zm-.772 17.315h-4.063a.771.771 0 0 0-.772.772v1.12h5.598v-1.12a.754.754 0 0 0-.763-.772Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.66 28.69h3.68v15.42h-3.68V28.69Z",
    fill: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.803 26.796h-5.598v1.122c0 .422.342.771.772.771h4.063a.771.771 0 0 0 .772-.771v-1.122h-.009Zm-.771 17.315h-4.063a.771.771 0 0 0-.772.772v1.12h5.598v-1.12a.76.76 0 0 0-.763-.772Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.164 28.69h3.68v15.42h-3.68V28.69Z",
    fill: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3 26.796h-5.598v1.122c0 .422.34.771.771.771h4.063a.771.771 0 0 0 .772-.771v-1.122H41.3Zm-.772 17.315h-4.063a.772.772 0 0 0-.772.772v1.12h5.599v-1.12a.754.754 0 0 0-.764-.772Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.66 28.69h3.681v15.42h-3.68V28.69ZM7.095 46.003h37.805v2.998H7.094v-2.998Z",
    fill: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.094 21.393h37.805v5.403H7.094v-5.403Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.736 49.002h42.527V52H4.736v-2.998Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 9.92 7.095 21.394h37.813L26.002 9.921Z",
    fill: "#DA4765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.773 16.933v2.364a2.597 2.597 0 0 1-2.365-2.364h2.365Zm0-2.812v2.365h-2.365a2.62 2.62 0 0 1 2.365-2.365Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13.666a3.048 3.048 0 0 0 0 6.094 3.048 3.048 0 0 0 0-6.094Zm-.227 5.63a2.597 2.597 0 0 1-2.365-2.363h2.364v2.364Zm0-2.81h-2.365a2.597 2.597 0 0 1 2.364-2.365v2.365Zm.454-2.365a2.597 2.597 0 0 1 2.365 2.365h-2.364V14.12Zm0 5.176v-2.364h2.365a2.604 2.604 0 0 1-2.364 2.364Z",
    fill: "#B33254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.591 16.933a2.604 2.604 0 0 1-2.364 2.364v-2.364h2.364Zm0-.447h-2.364V14.12a2.618 2.618 0 0 1 2.364 2.365ZM43.81 30.76h3.803v3.803h-3.803V30.76Zm0 7.475h3.803v3.803h-3.803v-3.803ZM4.387 30.761h3.802v3.803H4.387V30.76Zm0 7.475h3.802v3.803H4.387v-3.803Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.3531676956d617565814a4cff2bedbea.svg";
export { ForwardRef as ReactComponent };